<!--
 * @Description: 
 * @Author:  
 * @Date: 2024-08-01 14:27:44
 * @LastEditTime: 2024-09-10 12:00:36
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="news-top">
      <h1 class="news-title">{{newsDetail.title}}</h1>
      <div class="news-info">
        <span class="spa1">{{newsDetail.authorName}}</span>
        <span class="spa2">{{newsDetail.publishTime | time_moment('YYYY-MM-DD HH:mm')}}</span>
      </div>
    </div>
    <div class="news-content">
      <div class="custom-content" v-html="newsDetail.content"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import filter from 'js/filter'
import { getActAppMi } from '@/service/vbef'
export default {
  inject: ['wxShare'],
  metaInfo() {
    return {
      title:
        this.newsDetail.title ||
        filter.dealLanguage(this.activityDetail.name, this.activityDetail.enName),
    }
  },
  data() {
    return {
      loading: false,
      newsDetail: {},
    }
  },
  components: {},
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      activityDetail: (state) => state.activityDetail,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
    }),
  },
  created() {
    this.getActAppMi()
  },
  mounted() {},
  methods: {
    async getActAppMi() {
      this.loading = true
      let res = await getActAppMi({
        page: 1,
        size: 1,
        activityId: this.activityId,
        // isEnglish: this.language == 'en' ? 1 : 0,
        appMiId: this.$route.params.id,
      })
      this.loading = false
      if (res.code == 0 && res.data.length) {
        this.$set(this.$data, 'newsDetail', res.data[0])
        this.wxShare({
          title:
            this.newsDetail.title ||
            filter.dealLanguage(this.activityDetail.name, this.activityDetail.enName),
          linkurl: this.vbef_path + '/newsDetail/' + this.$route.params.id,
        })
      } else {
        this.$router.push('/404')
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.main-container
  padding 0.4rem
.news-top
  padding 0 0 0.2rem
  border-bottom 1px solid #e5e5e5
  .news-title
    font-size 0.36rem
    color #333333
    line-height 0.56rem
  .news-info
    margin-top 0.3rem
    font-size 0.24rem
    color #333333
    line-height 1.5
    display flex
    align-items center
    span+span
      margin-left 0.2rem
      padding-left 0.22rem
      position relative
      &:before
        content ''
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
        width 0.02rem
        height 0.2rem
        background #EEEEEE
.news-content
  >>> .custom-content
    padding 0.3rem 0
    overflow hidden
    width 100%
    font-size 0.32rem
    color #1D2129
    line-height 1.8
    text-align justify
    ol
      list-style auto
      li
        list-style auto
    ul
      list-style disc
      li
        list-style disc
    a
      color #2d7bc5
    em
      font-style italic
    img
      margin 0 auto
      display block
      max-width 100% !important
      height auto !important
    span
      max-width 100% !important
      padding 0
    p
      max-width 100% !important
      margin 0
      font-size 0.32rem
      color #1D2129
      line-height 1.8
      text-align justify
    table
      width 100%
      td
        border 1px solid #e5e5e5
    iframe
      width 100% !important
      height 200px !important
    section
      max-width 100% !important
</style>